<!-- Affichage d'une lame -->
<ng-template #boardElement let-productItem="productItem" let-index="index">
  <img #imageElement
       #boardImageElement
       [src]="productItem?.product?.path"
       [class.img-layer]="index === 0"
       (load)="onBoardImageLoad(productItem)"
       (error)="onBoardImageError(productItem)" />
</ng-template>

<div class="sublayers {{ item?.product?.type }}" [id]="'element' + item?.position">
  @switch (item?.product?.type) {
    <!-- Affiche un panneau avec des lames, décors, etc... -->
    @case (FencePreviewItemTypeEnum.Board) {
      <!-- Construction des panneaux -->
      <div class="vertical-group">
        <!-- Pose horizontale standard -->
        @if (!item.product.isVertical) {
          @for (board of item.product.items; track $index) {
            @switch (board.product.type) {
              <!-- Affiche l'entretoise -->
              @case (FencePreviewItemTypeEnum.Spacer) {
                <div [style.height]="getSpacerHeightWithRatio(board.product.height) + 'px'" [style.width]="'100%'"></div>
              }

              @case (FencePreviewItemTypeEnum.Board) {
                <ng-container *ngTemplateOutlet="boardElement; context: {productItem: board, index: $index}"></ng-container>
              }

              @case (FencePreviewItemTypeEnum.BoardCut) {
                <ng-container *ngTemplateOutlet="boardElement; context: {productItem: board, index: $index}"></ng-container>
              }

              <!-- Affiche les autres élements (décors, etc...) -->
              @default {
                <img #imageElement
                     [src]="board?.product?.path"
                     [class.img-layer]="$index === 0"
                     (load)="onBoardImageLoad(board)"
                     (error)="onBoardImageError(board)" />
              }
            }
          }
        }
        @else {
          <!-- Pose verticale -->
          <!-- Top profile -->
          <img #imageElement
                [src]="item.product.items[0]?.product?.path"
                [class.img-layer]="true"
                (load)="onBoardImageLoad(item.product.items[0])"
                (error)="onBoardImageError(item.product.items[0])" />

          <!-- On affiche les lames à la verticale -->
          <div class="horizontal-group">
            @for (board of item.product.items; track $index) {
              @switch (board.product.type) {
                @case (FencePreviewItemTypeEnum.Board) {
                  @if ($index !== 0 && $index !== item.product.items.length - 1) {
                    <img #imageElement
                         #boardImageElement
                        [src]="board?.product?.path"
                        [class.img-layer]="false"
                        (load)="onBoardImageLoad(board)"
                        (error)="onBoardImageError(board)"
                        class="img-vertical-board"
                        [class.is-partial]="item.product.isPartial" />
                  }
                }
              }
            }
          </div>

          <!-- Bottom profile -->
          <img #imageElement
                [src]="item.product.items[item.product.items.length - 1]?.product?.path"
                [class.img-layer]="false"
                (load)="onBoardImageLoad(item)"
                (error)="onBoardImageError(item)" />
        }
      </div>
    }

    @case (FencePreviewItemTypeEnum.SealedPost) {
      <ng-container *ngTemplateOutlet="postElement; context: {item: item}"></ng-container>
    }

    @case (FencePreviewItemTypeEnum.PostWithPlate) {
      <ng-container *ngTemplateOutlet="postElement; context: {item: item}"></ng-container>
    }

    <!-- Affiche les poteaux, les portillons et les décors verticaux -->
    @default {
      <img #imageElement
           [src]="item?.product?.path"
           class="img-{{ item?.product?.type }}"
           (load)="onImgLoad(item)"
           (error)="onImgError(item)" />
    }
  }
</div>

<!-- Affichage d'un poteau -->
<ng-template #postElement let-item="item">
  <img #imageElement
      [src]="item?.product?.path"
      class="img-{{ item?.product?.type }}"
      (load)="onImgLoad(item)"
      (error)="onImgError(item)"
      [class.post-type-margin]="item.product.isVertical" />
</ng-template>
